import styled from "@emotion/styled"

const CaseStudyValue = styled.div`
  line-height: 1.87;
  color: ${({ theme }) => theme.palette.common.black};
  font-size: 18px;
`

export default CaseStudyValue
